import { Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import useToggle from "../../../state/useToggle";

export const CreditModelPriceInput = ({
  saveAttribute,
  partner,
  ficoPrice,
  vantagePrice,
  residentScorePrice,
}) => {
  const [ficoPriceTemp, setFicoPrice] = useState(0);
  const [vantagePriceTemp, setVantagePrice] = useState(0);
  const [residentScorePriceTemp, setResidentScorePrice] = useState(0);
  const confirmToggle = useToggle();

  const hasChanges =
    Number(ficoPriceTemp) !== Number(ficoPrice) ||
    Number(vantagePriceTemp) !== Number(vantagePrice) ||
    Number(residentScorePriceTemp) !== Number(residentScorePrice);

  useEffect(() => {
    setVantagePrice(vantagePrice);
    setFicoPrice(ficoPrice);
    setResidentScorePrice(residentScorePrice);
  }, [ficoPrice, vantagePrice, residentScorePrice]);

  return (
    <form className="flex h-20 gap-4 items-center">
      <div>
        <p>Vantage 4</p>
        <input
          value={vantagePriceTemp}
          onChange={(e) => {
            setVantagePrice(e.target.value);
          }}
        />
      </div>
      <div>
        <p>FICO 9</p>
        <input
          value={ficoPriceTemp}
          onChange={(e) => {
            setFicoPrice(e.target.value);
          }}
        />
      </div>
      <div>
        <p>Resident score</p>
        <input
          value={residentScorePriceTemp}
          onChange={(e) => {
            setResidentScorePrice(e.target.value);
          }}
        />
      </div>
      <Button
        variant="contained"
        color="primary"
        disabled={!hasChanges}
        onClick={confirmToggle.turnOn}
      >
        Save
      </Button>
      <ConfirmationDialog
        open={confirmToggle.on}
        onCancel={() => {
          setFicoPrice(ficoPrice);
          setVantagePrice(vantagePrice);
          setResidentScorePrice(residentScorePrice);
          confirmToggle.turnOff();
        }}
        onConfirm={async () => {
          try {
            await saveAttribute({
              settings: {
                ...partner.settings,
                boomScreenScreeningFees: {
                  ...partner.boomScreenScreeningFees,
                  creditReport05206: ficoPriceTemp * 100,
                  creditReport05402: vantagePriceTemp * 100,
                  creditReport00A72: residentScorePriceTemp * 100,
                },
              },
            });
            toast.success("Prices updated successfully");
            confirmToggle.turnOff();
          } catch (error) {
            toast.error(error?.message || "Failed to update prices");
          }
        }}
        title="Confirm changes"
        text="Are you sure you want to save these price changes?"
        cancelProps={{ children: "Cancel" }}
        confirmProps={{ children: "Confirm" }}
      />
    </form>
  );
};
